import React from 'react'
import {Grid, Avatar} from '@mui/material'

export const DummyImage = ({width, height}) => {
  return (
    <Grid
      container
      direction="row"
      sx={{        
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Avatar variant='square' sx={{ width: width, height: height, bgcolor: 'grey.100', border: '1px solid #E2E2E2' }}>
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.92773 3.80002V18.2H20.255V3.80002H1.92773ZM3.23683 5.10911H18.9459V14.2112L15.4893 10.7343L15.0186 10.2637L12.0529 13.2294L8.28926 9.42518L7.81864 8.95456L3.23683 13.5364V5.10911ZM16.3277 6.4182C15.9805 6.4182 15.6476 6.55612 15.4021 6.80162C15.1566 7.04713 15.0186 7.3801 15.0186 7.72729C15.0186 8.07448 15.1566 8.40746 15.4021 8.65296C15.6476 8.89846 15.9805 9.03638 16.3277 9.03638C16.6749 9.03638 17.0079 8.89846 17.2534 8.65296C17.4989 8.40746 17.6368 8.07448 17.6368 7.72729C17.6368 7.3801 17.4989 7.04713 17.2534 6.80162C17.0079 6.55612 16.6749 6.4182 16.3277 6.4182ZM7.81864 10.8161L13.8326 16.8909H3.23683V15.3979L7.81864 10.8161ZM15.0186 12.1252L18.9459 16.0525V16.8909H15.6935L12.9732 14.1497L15.0186 12.1252Z" fill="#E2E2E2"/>
          </svg>
        </Avatar>
    </Grid>
  )
}
